import { createSelector } from 'reselect';
import { Map } from 'immutable';
import { selectCurrentInstitutionPath } from '../../Institutions/CurrentInstitutionPath/selectors';

import {
  selectQuery,
  selectType,
  selectPayload,
  selectState,
} from '../../location/selectors';
import { selectIsInCourse } from '../selectors';

export const selectOpenModuleSet = createSelector(
  [selectIsInCourse, selectQuery],
  (isInCourse, query) => {
    if (isInCourse) {
      return query.get('moduleSet') || null;
    } else {
      return null;
    }
  }
);

export const selectMakeSetCurrentModuleSetAction = createSelector(
  [
    selectIsInCourse,
    selectType,
    selectQuery,
    selectPayload,
    selectState,
    selectCurrentInstitutionPath,
  ],
  (isInCourse, type, query, params, state, institutionPrefix) => ({
    setName,
  }) => {
    if (isInCourse) {
      return new Map({
        type,
        params,
        query: query.set('moduleSet', setName),
        state: state.set('institutionPrefix', institutionPrefix),
      });
    } else {
      return null;
    }
  }
);
